module.exports = __webpack_public_path__ + "img/shaparak-new-version.33606f2e.png";